import gql from 'graphql-tag';


export const ApproveRevenueViewer: any = gql`
  mutation approveRevenueViewer($ID:ID!){
    approveRevenueViewer(_id: $ID){_id}
  }
`;

export const GetRequestsCount: any = gql`
  query GetRequestsCount {
    GetRequestsCount
  }
`;

export const createApplicationFeatures: any = gql`
mutation createApplicationFeatures($features: [FeatureInput]!){
  createApplicationFeatures(features: $features)
}
`;

export const loadApplicationFeatures: any = gql`
query loadApplicationFeatures{
  loadApplicationFeatures {
    _id,
    name,
    value
  }
}
`;

export const loadAllRestrictedApplications: any = gql`
query loadAllRestrictedApplications{
  loadAllRestrictedApplications {
    _id,
    features {
      _id
      name
      value
    },
    visibleFeatures {
      _id
      name
      value
    },
    comments
  }
}
`;

export const loadRestrictedApplication: any = gql`
query loadRestrictedApplication ($id: String!){
  loadRestrictedApplication (id: $id) {
    _id,
    features {
      _id
      name
      value
    },
    visibleFeatures {
      _id
      name
      value
    },
    comments
  }
}
`;

export const removeApplicationFeature: any = gql`
mutation removeApplicationFeature($id: ID!){
  removeApplicationFeature(id: $id)
}
`;

export const setApplicationRestriction: any = gql`
mutation setApplicationRestriction($restriction:RestrictedApplicationInput!){
  setApplicationRestriction(restriction: $restriction)
}
`;

export const editApplicationRestriction: any = gql`
mutation editApplicationRestriction($restriction:RestrictedApplicationInput!){
  editApplicationRestriction(restriction: $restriction)
}
`;

export const removeApplicationRestriction: any = gql`
mutation removeApplicationRestriction($id:String){
  removeApplicationRestriction(id: $id)
}
`;





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/queries/general.model.ts